import { render, staticRenderFns } from "./HeadingItem.vue?vue&type=template&id=734f8fa2"
import script from "./HeadingItem.vue?vue&type=script&lang=js"
export * from "./HeadingItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports